import React from "react";
import {observer} from "mobx-react";
import styled, {css} from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";
import {PassengerTypeSelectorComponent} from "./passenger-type-selector.component";
import {HORIZONTAL_SPACING_PX, VERTICAL_SPACING_PX} from "../../css-global-constants";
import {IDropDownController} from "../../drop-down/drop-down-controller.interface";
import {MobileDropDownListHeaderComponent} from "../../drop-down/mobile-drop-down-list-header/mobile-drop-down-list-header.component";
import {PrimaryButtonBox} from "../../basic-componentes/primary-button.box";

const PassengersTypesDropDownListBox = styled.div<{isMobileView: boolean}>`
    display: flex;
    flex-direction: column;
    width: 100%;
    
    ${
        props => props.isMobileView 
                ? css`
                  padding: 0;
                `
                : css`
                  padding: 0 ${HORIZONTAL_SPACING_PX} ${VERTICAL_SPACING_PX} ${HORIZONTAL_SPACING_PX};
                `
    }   
`

const DoneButtonContainerBox = styled.div<{isMobileView: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    ${
          props => props.isMobileView
                  ? css`
                      justify-content: center;
                    `
                  : css`
  
                    `
    }
`

const DoneButtonBox = styled(PrimaryButtonBox)`
    margin-top: ${VERTICAL_SPACING_PX};
    min-width: 150px;
    padding: ${VERTICAL_SPACING_PX};
    
`

const MaximumPassengersLimitReachedMessage = styled.div`
    font-size: ${props => props.theme.fontSize.small};
    margin-top: ${VERTICAL_SPACING_PX};
    line-height: 1;
`


interface PassengersTypesDropDownListComponentProps {
    dropDownController: IDropDownController;
}

export const PassengersTypesDropDownListComponent: React.FC<PassengersTypesDropDownListComponentProps> = observer((props) => {
    const services = useServices();
    const passengerTypes = services.flightSearch.searchController.passengers;

    const renderErrorMessage = () => {
        if(passengerTypes.passengersMaximumLimitReachedErrorMessage) {
            return (
                <MaximumPassengersLimitReachedMessage>
                    {passengerTypes.passengersMaximumLimitReachedErrorMessage}
                </MaximumPassengersLimitReachedMessage>
            )
        }

        return null;
    }

    const onCloseClick = () => {
        props.dropDownController.closeDropDown();
    }

    const renderHeader = () => {
        if(services.application.isInMobileView) {
            return (
                <MobileDropDownListHeaderComponent onBackClick={onCloseClick}>
                    {services.language.translate('Select passengers')}
                </MobileDropDownListHeaderComponent>
            );
        }

        return null;
    }

    const renderDoneButton = () => {

        return (
            <DoneButtonContainerBox isMobileView={services.application.isInMobileView}>
                <DoneButtonBox onClick={onCloseClick}>
                    {services.language.translate('Done')}
                </DoneButtonBox>
            </DoneButtonContainerBox>
        );

    }


    return (
        <PassengersTypesDropDownListBox isMobileView={services.application.isInMobileView}>
            {renderHeader()}
            {passengerTypes.getAll().map(pt => <PassengerTypeSelectorComponent key={pt.description} passengerTypeSelector={pt}/>)}
            {renderErrorMessage()}
            {renderDoneButton()}
        </PassengersTypesDropDownListBox>
    );
});
